import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CollaborationDetails, { detailGroups } from "./CollaborationDetails";
import { getCollaborationById } from "../../../api/admin/collaborations";
import { listImagesByCollaboration } from "../../../api/admin/images";
import { listCommentsByCollaboration } from "../../../api/admin/comments";
import { useAuth } from "../../../context/AuthContext";

interface CollaborationData {
  nome_especie?: string;
  data?: string;
  pais?: string;
  regiao?: string;
  estado?: string;
  municipio?: string;
  latitude?: string;
  longitude?: string;
  altitude?: string;
  coletor?: string;
  instituicao_coletor?: string;
  autor_foto?: string;
  instituicao_autor?: string;
  SISBIO?: string;
  SISGEN?: string;
  observacoes?: string;
  status?: string;
}
interface CommentItem {
  id: number;
  assunto?: string;
  conteudo?: string;
  created_at?: string;
  autor?: { user_id: number; nome_completo?: string } | null;
}
interface ImageItem {
  id: number;
  url: string;
  status?: string;
  code?: string;
}

const CollaborationReadOnlyAdmin: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getCsrfToken, user } = useAuth();
  const token = getCsrfToken();
  const [data, setData] = useState<CollaborationData | null>(null);
  const [comments, setComments] = useState<CommentItem[]>([]);
  const [images, setImages] = useState<ImageItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!id) return;
      setLoading(true);
      setError(null);
      try {
        const detail = await getCollaborationById(Number(id), token);
        if (mounted) setData(detail);
        try {
          const response = await listCommentsByCollaboration(Number(id), token!, 1, 100);
          if (mounted)
            setComments(
              response.items.map((c: any) => ({
                id: c.comentario_id || c.id,
                assunto: c.assunto || c.titulo || c.title || "",
                conteudo: c.conteudo || c.comentario || c.texto || c.text || "",
                created_at:
                  c.created_at || c.data_criacao || c.data || undefined,
                autor: c.autor || c.user || null,
              }))
            );
          if (
            mounted &&
            (!response.items || response.items.length === 0) &&
            process.env.NODE_ENV !== "production"
          ) {
            // eslint-disable-next-line no-console
            console.warn(
              "[CollaborationReadOnlyAdmin] Nenhum comentário retornado para colaboração",
              id
            );
          }
        } catch {}
        try {
          const response = await listImagesByCollaboration(Number(id), token!, 1, 100);
          if (mounted)
            setImages(
              response.items.map((i: any) => ({
                id: i.imagem_id,
                url: i.url_imagem,
                status: i.status,
                code: i.codigo_imagem,
              }))
            );
        } catch {}
      } catch (e: any) {
        if (mounted) setError(e?.message || "Erro ao carregar");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [id, token]);

  const values: Record<string, string | undefined> = {};
  detailGroups.forEach((group) => group.fields.forEach((field) => {
    values[field.name] = data?.[field.key as keyof CollaborationData];
  }));
  values.observations = data?.observacoes;
  return (
    <CollaborationDetails id={id} userName={user?.nome_completo || "Administrador"}
      loading={loading} error={error} values={values} status={data?.status}
      images={images} comments={comments.map((comment) => ({ id: comment.id, title: comment.assunto, text: comment.conteudo, author: comment.autor?.nome_completo }))}
      onBack={() => navigate("/solicitacoes-admin")} />
  );
};

export default CollaborationReadOnlyAdmin;
